<template>
    <v-dialog v-model="dialog" max-width="850px" persistent>
        <v-card light>
            <v-card-title>
                <div>
                    <h3 class="headline mb-0 green--text">Agregar Contenido</h3>
                </div>
            </v-card-title>
            <v-card-text class="p-relative">
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-radio-group row light v-model="form.content_type">
                            <v-radio label="Texto" value="text" light></v-radio>
                            <v-radio label="Multimedia" value="multimedia" light></v-radio>
                        </v-radio-group>
                    </v-flex>
                    <template v-if="form.content_type === 'text'">
                        <v-flex xs12 sm6>
                            <p class="green--text">Español</p>
                            <ckeditor
                                v-model="form.text_es"
                                :editor="editor"
                                :config="editorConfig"></ckeditor>
                            <span
                                class="custom-error"
                                v-show="showErrors && form.text_es === ''">Este campo es obligatorio</span>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <p class="green--text">Inglés</p>
                            <ckeditor
                                v-model="form.text_en"
                                :editor="editor"
                                :config="editorConfig"></ckeditor>
                            <span
                                class="custom-error"
                                v-show="showErrors && form.text_en === ''">Este campo es obligatorio</span>
                        </v-flex>
                    </template>
                    <template v-if="form.content_type === 'multimedia'">
                        <v-flex xs12 sm6>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <p class="green--text">Español</p>
                                    <v-text-field
                                        v-model="form.action_es"
                                        label="Acción imagen"
                                        color="green"
                                        ref="action_es"
                                        type="url"
                                        light>
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-radio-group row light v-model="form.media_type_es">
                                        <v-radio label="Imagen" value="image" light></v-radio>
                                        <v-radio label="Video" value="video" light></v-radio>
                                    </v-radio-group>
                                </v-flex>
                                <v-flex xs12>
                                    <v-btn color="info" @click="openFileChooser( 'es' )">
                                        Subir {{ form.media_type_es === 'image' ? 'imagen' : 'video' }}
                                        <v-icon right dark>cloud_upload</v-icon>
                                    </v-btn>
                                    <span
                                        class="custom-error"
                                        v-show="showErrors && form.file_es === null">Este campo es obligatorio</span>
                                    <InputFile ref="inputFile_es" :extensions="permittedExtensions( 'es' )" @fileChange="fileChange"></InputFile>
                                </v-flex>
                                <v-flex xs12>
                                    <v-card-media
                                        :src="form.image_es"
                                        height="200px"
                                        contain
                                    ></v-card-media>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <p class="green--text">Inglés</p>
                                    <v-text-field
                                        v-model="form.action_en"
                                        label="Acción imagen"
                                        color="green"
                                        ref="action_en"
                                        type="url"
                                        light>
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-radio-group row light v-model="form.media_type_en">
                                        <v-radio label="Imagen" value="image" light></v-radio>
                                        <v-radio label="Video" value="video" light></v-radio>
                                    </v-radio-group>
                                </v-flex>
                                <v-flex xs12>
                                    <v-btn color="info" @click="openFileChooser( 'en' )">
                                        Subir {{ form.media_type_en === 'image' ? 'imagen' : 'video' }}
                                        <v-icon right dark>cloud_upload</v-icon>
                                    </v-btn>
                                    <span
                                        class="custom-error"
                                        v-show="showErrors && form.file_en === null">Este campo es obligatorio</span>
                                    <InputFile ref="inputFile_en" :extensions="permittedExtensions( 'en' )" @fileChange="fileChange"></InputFile>
                                </v-flex>
                                <v-flex xs12>
                                    <v-card-media
                                        :src="form.image_en"
                                        height="200px"
                                        contain
                                    ></v-card-media>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </template>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" flat @click="close">Cancelar</v-btn>
                <v-btn color="green darken-1" flat @click="save">Guardar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>    
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import InputFile from '@/components/helpers/InputFile';


export default {
    name: 'AddContentSectionModal',
    props: {
        dialog: {
            type: Boolean,
            required: true
        },
        sectionPos: {
            type: Number,
            required: true
        }
    },
    components: {
        InputFile
    },
    data() {
        return {
            form: {
                text_es: '',
                text_en: '',
                action_es: '',
                action_en: '',
                content_type: 'text',
                media_type_es: 'image',
                media_type_en: 'image',
                file_es: '',
                file_en: '',
                image_es: '',
                image_en: ''
            },
            editor: ClassicEditor,
            editorConfig: {
                toolbar: [ 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote' ],
            },
            rules: {
                required: [
                    val =>  ((val === 0 ? '0' : String(val)) || '').length > 0 || 'Este campo es obligatorio'
                ]
            },
            inputFileClicked: null,
            showErrors: false
        }
    },
    computed: {
        ...mapGetters([
            'currentSponsorship'
        ]),
    },
    methods: {
        ...mapActions([
            'createSection',
            'loadSponsorship',
            'addSectionContent'
        ]),
        close() {

            this.clearForm();
            this.$emit( 'close' );
        },
        permittedExtensions( lang ) {

            return this.form[ `media_type_${ lang }` ] === 'image'
                    ? 'image/x-png, image/jpeg'
                    : '.mp4';
        },
        openFileChooser( lang ) {

            this.inputFileClicked = lang;
            this.$refs[ `inputFile_${ lang }` ].open();
        },
        fileChange( img, imgFile ) {

            this.form[ `image_${ this.inputFileClicked }` ] = img.src;
            this.form[ `file_${ this.inputFileClicked }` ] = imgFile;
        },
        clearForm() {

            this.form = {
                text_es: '',
                text_en: '',
                action_es: '',
                action_en: '',
                content_type: 'text',
                media_type_es: 'image',
                media_type_en: 'image',
                file_es: '',
                file_en: '',
                image_es: '',
                image_en: ''
            }
        },
        save() {

            this.showErrors = true;

            if (
                    ( this.form.content_type === 'text' && !this.form.text_es && !this.form.text_en )
                    ||
                    ( this.form.content_type === 'multimedia' && !this.form.file_es && !this.form.file_en )
                ) {

                    return;
            }

            const position = ( this.currentSponsorship.sections[ this.sectionPos ].contents.length / 2) + 1;
            const data_es = {
                lang: 'es',
                type: this.form.content_type === 'text' ? this.form.content_type : 'image',
                section_sponsorship_id: this.currentSponsorship.sections[ this.sectionPos ].id,
                text: this.form.text_es || undefined,
                media: this.form.file_es,
                action: this.form.action_es || undefined,
                position
            }

            const data_en = {
                lang: 'en',
                type: this.form.content_type === 'text' ? this.form.content_type : 'image',
                section_sponsorship_id: this.currentSponsorship.sections[ this.sectionPos ].id,
                text: this.form.text_en || undefined,
                media: this.form.file_en,
                action: this.form.action_en || undefined,
                position 
            }

            this.addSectionContent({
                data: data_es,
                callback: () => this.addSectionContent({
                    data: data_en,
                    callback: () => this.loadSponsorship({
                        id: this.currentSponsorship.id,
                        callback: () => this.close()
                    })
                })
            });
        }
    }
}
</script>

<style>
    .custom-error {
        color: rgb(255, 82, 82);
        font-size: 12px;
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/sponsorships/addContentSectionModal.vue